import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "./blogFirebase";

const PENDING_COLLECTION = "blog_posts_pending";
const REVIEWABLE_STATUSES = ["pending_approval", "regenerating"];

/**
 * Live subscription to the review queue, split by origin.
 *
 * New posts and content refreshes need different review treatment — a refresh
 * updates a page that already ranks, so it is judged on what changed rather
 * than on the post as a whole — and the flat list gave no way to tell them
 * apart. The `isRefresh` flag is set by saveRefreshToFirestore().
 */
export function usePendingPosts() {
  const [posts, setPosts]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, PENDING_COLLECTION),
      where("status", "in", REVIEWABLE_STATUSES),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(q, (snap) => {
      setPosts(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, (err) => {
      console.error("BlogReview pending snapshot error:", err);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  const { newPosts, refreshPosts } = useMemo(() => ({
    newPosts:     posts.filter(p => !p.isRefresh),
    refreshPosts: posts.filter(p => p.isRefresh),
  }), [posts]);

  return { newPosts, refreshPosts, loading };
}
